import landingPageModule from '../landingPageModule';
import { EnvironmentUrls } from "Roblox";

function signupService(httpService, signupConstants) {
    "ngInject";

    function signup(params, signUpUrl) {
        var url = signUpUrl || EnvironmentUrls.authApi + signupConstants.urls.signUpApi;
        var urlConfig = {
            url: url
        };

        return httpService.httpPost(urlConfig, params, true);
    };

    function getMetadata() {
        var url = EnvironmentUrls.authAppSite + signupConstants.urls.metaData;
        var urlConfig = {
            url: url
        };

        return httpService.httpGet(urlConfig);
    }

    function getMetadataV2() {
        var url = EnvironmentUrls.authApi + signupConstants.urls.metadataV2
        var urlConfig = {
            url: url
        };

        return httpService.httpGet(urlConfig);
    }

    var signupService = {
        signup: signup,
        getMetadata: getMetadata,
        getMetadataV2: getMetadataV2
    };

    return signupService;
}

landingPageModule.factory("signupService", signupService);

export default signupService;